import { useParams } from "react-router-dom";
// import MapEsocrona from './MapEsocrona';
import RutaSalud from "./rutaSalud";
import { useEffect } from "react";

export default function ShowMapeoEntomologico() {


  // const {entidad, level} = useParams()

  useEffect(() => {
    document.title ='entom'
  }, [])

  return (
    <div className="contentSimple"  >
      <div className="main-container">
        <h3 className='text-center mt-2'>MAPA DE INFESTACION ENTOMOLOGICO</h3>
        <RutaSalud />

      </div>
    </div>
  );
}